"use strict";
exports.__esModule = true;
exports.compareParseObjects = void 0;
var compareParseObjects = function (a, b, sorts) {
    var order = sorts[0];
    var operator = order.slice(0, 1);
    var isDescending = operator === '-';
    if (isDescending) {
        order = order.substring(1);
    }
    if (order === '_created_at') {
        order = 'createdAt';
    }
    if (order === '_updated_at') {
        order = 'updatedAt';
    }
    if (!(/^[A-Za-z][0-9A-Za-z_]*$/).test(order) || order === 'password') {
        throw new Parse.Error(Parse.Error.INVALID_KEY_NAME, "Invalid Key: " + order);
    }
    var field1 = a.get(order);
    var field2 = b.get(order);
    if (field1 < field2) {
        return isDescending ? 1 : -1;
    }
    if (field1 > field2) {
        return isDescending ? -1 : 1;
    }
    if (sorts.length > 1) {
        var remainingSorts = sorts.slice(1);
        return (0, exports.compareParseObjects)(a, b, remainingSorts);
    }
    return 0;
};
exports.compareParseObjects = compareParseObjects;
//# sourceMappingURL=util.js.map